import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import AuthGate from "@/components/AuthGate";

// Environnement TEST/DEV : suffixe dans l'onglet du navigateur (REACT_APP_ENV_LABEL injecté au build)
if (process.env.REACT_APP_ENV_LABEL) {
  document.title = `Admissibilité — ${process.env.REACT_APP_ENV_LABEL}`;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthGate>
      {(user, logout) => <App authUser={user} onLogout={logout} />}
    </AuthGate>
  </React.StrictMode>,
);
